import { FuelRadio, FuelTypography } from "@frete.com/fuel-react"
import styled from "styled-components"

export const Title = styled(FuelTypography).attrs({ size: 'caption', color: 'neutral-strong', variant: 'bold' })`
  text-transform: capitalize;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  background-color: white;
  max-height: 384px;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: ${({ theme }) => theme.border.radius.small};
    background: ${({ theme }) => theme.color.border.neutral.default};
    height: 200px;
  }

  & > :last-child {
    margin-bottom: ${({ theme }) => theme.spacing.km1};
  }
`

export const Wrapper = styled.div`
  overflow-y: hidden;
  width: 100%;
  position: absolute;
  top: ${({ theme }) => theme.spacing.km14};
  z-index: 2;
  border-radius: ${({ theme }) => theme.border.radius.large};
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.medium};
  padding-top: ${({ theme }) => theme.spacing.km6};
  padding-left: ${({ theme }) => theme.spacing.km3};
  padding-bottom: ${({ theme }) => theme.spacing.km3};
  padding-right: ${({ theme }) => theme.spacing.km3};
  background-color: white;
`

export const Radio = styled(FuelRadio)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`
